export default __webpack_public_path__ + "static/media/gmc-car-icon.c18a259b.png";